import React, { Component } from "react";
import axios from "../../util/axios";
import moment from "moment";
import ReportsViewTable from "../../components/reportmanagement/reportsViewTable";
import { trackPromise } from "react-promise-tracker";
import { Link } from "react-router-dom";
import Timezone from "../../components/common/Timezone";
import Back from "../../components/common/Back";
import getCobrand from "../../util/getCobrand";

class ReportsView extends Component {
  state = {
    reports: [],
    jobId: this.props.match ? this.props.match.params.jobId : "",
    reportId: this.props.match ? this.props.match.params.reportId : "",
    cobrand: getCobrand(),
    jobStatus: "init"
  };

  async componentDidMount() {
    trackPromise(
      axios
        .get("/api/report/job/data/" + this.state.jobId, {
          headers: {
            Authorization: JSON.parse(localStorage.getItem("userData")).token,
            "Cobrand-Id": this.state.cobrandId
          }
        })
        .then(res => {
          const reportsViewData = res.data.data;
          this.setState({ reportName: res.data.name });
          this.setState({
            fromDate: moment
              .utc(res.data.from)
              .local()
              .format("MM-DD-YYYY")
          });
          this.setState({
            toDate: moment
              .utc(res.data.to)
              .local()
              .format("MM-DD-YYYY")
          });
          //cobrandId field is coming differently for summary report
          this.setState({
            cobrandId: res.data.cobrandId
              ? res.data.cobrandId
              : res.data.data[0].cobrandId
          });
          this.setState({ reports: reportsViewData });
          this.setState({ jobStatus: "created" });
          // console.log(JSON.stringify(responseJobData));
        })
        .catch(err => {
          console.log(err);
        })
    );
  }

  showPrintView = () => {
    localStorage.setItem("printVals", "");
    this.props.history.push({
      pathname: "/PrintView",
      printVals: {
        reports: this.state.reports,
        reportId: this.state.reportId,
        jobId: this.state.jobId,
        reportName: this.state.reportName,
        fromDate: this.state.fromDate,
        toDate: this.state.toDate,
        cobrandId: this.state.cobrandId,
        duration: JSON.parse(localStorage.getItem("reportProps"))
          .selectedDuration
      }
    });
  };

  render(props) {
    const { reports } = this.state;
    const { reportId } = this.state;

    let selectedDuration = "";

    if (this.props.location.reportProps) {
      selectedDuration = this.props.location.reportProps.selectedDuration;
      localStorage.setItem(
        "reportProps",
        JSON.stringify(this.props.location.reportProps)
      );
    } else if (localStorage.getItem("reportProps")) {
      selectedDuration = JSON.parse(localStorage.getItem("reportProps"))
        .selectedDuration;
    }
    return (
      <React.Fragment>
        <div className="container main">
          <div className="mt-4">
            <Back uri={"/reports/" + this.state.cobrandId} />
          </div>
          <div class="heading mt-4">{this.state.reportName}</div>
          <div className="sub-heading mt-2">
            <span> COBRAND: </span>
            {this.state.cobrand.name} ({this.state.cobrand.id})
          </div>
          <div className="sub-heading mb-4">
            <span> DURATION: </span>
            {selectedDuration} ( {this.state.fromDate} - {this.state.toDate} )
          </div>

          <div className="row">
            <div className="col-12 text-right mb-4">
              <button
                className="btn btn-secondary "
                onClick={this.showPrintView}
              >
                <i className="fas fa-print form-control-feedback" />
                &nbsp;Printable View
              </button>
            </div>
          </div>
          {this.state.reports.length > 0 && (
            <div className="row">
              <div className="col">
                {(reportId === "101" || reportId === "102") && (
                  <Timezone label="* Times are displayed in" />
                )}

                <ReportsViewTable
                  reports={reports}
                  reportId={reportId}
                  pagination={
                    reportId == "101" || reportId == "102" ? true : false
                  }
                  paginationPerPage={50}
                  paginationRowsPerPageOptions={[50, 25, 20, 15, 10]}
                />
              </div>
            </div>
          )}
        </div>
      </React.Fragment>
    );
  }
}

export default ReportsView;
